import { callEndpoint } from '../backend';

const REAUTH_EXPIRES_AT_KEY = 'emailChangeReauthExpiresAt';
const PENDING_CONFIRM_TOKEN_KEY = 'emailChangePendingConfirmToken';

const confirmedTokenKey = (token) => `emailChangeConfirmed:${token}`;

export const setEmailChangeReauthExpiresAt = (isoTimestamp) => {
  if (typeof window !== 'undefined' && window.sessionStorage) {
    window.sessionStorage.setItem(REAUTH_EXPIRES_AT_KEY, isoTimestamp);
  }
};

export const clearEmailChangeReauth = () => {
  if (typeof window !== 'undefined' && window.sessionStorage) {
    window.sessionStorage.removeItem(REAUTH_EXPIRES_AT_KEY);
  }
};

export const hasActiveEmailChangeReauth = () => {
  if (typeof window === 'undefined' || !window.sessionStorage) {
    return false;
  }
  const expiresAt = window.sessionStorage.getItem(REAUTH_EXPIRES_AT_KEY);
  if (!expiresAt) {
    return false;
  }
  return Date.parse(expiresAt) > Date.now();
};

export const syncEmailChangeReauthFromServer = async () => {
  const status = await fetchEmailChangeReauthStatus();
  if (status?.active && status?.expiresAt) {
    setEmailChangeReauthExpiresAt(status.expiresAt);
    return true;
  }
  clearEmailChangeReauth();
  return false;
};

export const storePendingEmailChangeConfirmToken = (token) => {
  if (typeof window !== 'undefined' && window.sessionStorage && token) {
    window.sessionStorage.setItem(PENDING_CONFIRM_TOKEN_KEY, token);
  }
};

export const consumePendingEmailChangeConfirmToken = () => {
  if (typeof window === 'undefined' || !window.sessionStorage) {
    return null;
  }
  const token = window.sessionStorage.getItem(PENDING_CONFIRM_TOKEN_KEY);
  if (token) {
    window.sessionStorage.removeItem(PENDING_CONFIRM_TOKEN_KEY);
  }
  return token;
};

export const getConfirmedEmailChangeResult = (token) => {
  if (typeof window === 'undefined' || !window.sessionStorage || !token) {
    return null;
  }
  return window.sessionStorage.getItem(confirmedTokenKey(token));
};

export const storeConfirmedEmailChangeResult = (token, email) => {
  if (
    typeof window !== 'undefined' &&
    window.sessionStorage &&
    token &&
    email
  ) {
    window.sessionStorage.setItem(confirmedTokenKey(token), email);
    window.sessionStorage.removeItem(PENDING_CONFIRM_TOKEN_KEY);
  }
};

export const requestEmailChangeReauth = () =>
  callEndpoint(callEndpoint.endpoints.requestEmailChangeReauth);

export const verifyEmailChangeReauth = (reauthToken) =>
  callEndpoint(callEndpoint.endpoints.verifyEmailChangeReauth, {
    reauthToken,
  });

export const requestEmailChange = (newEmail) =>
  callEndpoint(callEndpoint.endpoints.requestEmailChange, { newEmail });

export const confirmEmailChange = (emailToken) =>
  callEndpoint(callEndpoint.endpoints.confirmEmailChange, { emailToken });

export const fetchEmailChangeReauthStatus = () =>
  callEndpoint(callEndpoint.endpoints.emailChangeReauthStatus);
